import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=7d00ea52&scoped=true&"
var script = {}
import style0 from "./IconClose.vue?vue&type=style&index=0&id=7d00ea52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d00ea52",
  null
  
)

export default component.exports